import { del, get, set } from 'idb-keyval';
import { PersistStorage } from 'zustand/middleware';
import { getNameWithTeamId } from '../../../../../utils/getPersisterKeyWithTeamId.util';
import { OfflineDownloadStatusStoreData } from '../types/offlineDownloadStatus.types';

export const getOfflineDownloadStatusDBStorage = (
  teamId?: string,
): PersistStorage<OfflineDownloadStatusStoreData> => ({
  setItem: async (name, value) => {
    const nameWithTeamId = getNameWithTeamId(name, teamId);
    if (!nameWithTeamId) {
      return;
    }

    if (!value.state.cachedData) {
      await del(nameWithTeamId);
    } else {
      await set(nameWithTeamId, value);
    }
  },
  getItem: async (name) => {
    const nameWithTeamId = getNameWithTeamId(name, teamId);
    if (!nameWithTeamId) {
      return;
    }

    const value = await get(nameWithTeamId);
    return value;
  },
  removeItem: async (name) => {
    const nameWithTeamId = getNameWithTeamId(name, teamId);
    if (!nameWithTeamId) {
      return;
    }

    await del(nameWithTeamId);
  },
});
